import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "fw-bolder" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = { class: "card-body p-9" }
const _hoisted_9 = { class: "row mb-5" }
const _hoisted_10 = { class: "col-md-12 fv-row" }
const _hoisted_11 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_12 = { class: "d-flex col-lg-12 fv-row" }
const _hoisted_13 = { class: "indicator-label" }
const _hoisted_14 = { class: "indicator-progress" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "row mb-5" }
const _hoisted_19 = { class: "col-md-6 fv-row" }
const _hoisted_20 = { class: "d-flex align-items-center fs-5 fw-bold mb-2" }
const _hoisted_21 = { class: "required" }
const _hoisted_22 = { class: "col-lg-12 fv-row" }
const _hoisted_23 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "col-md-6 fv-row" }
const _hoisted_26 = { class: "d-flex align-items-center fs-5 fw-bold mb-2" }
const _hoisted_27 = { class: "required" }
const _hoisted_28 = { class: "col-lg-12 fv-row" }
const _hoisted_29 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "row mb-5" }
const _hoisted_32 = { class: "col-md-6 fv-row" }
const _hoisted_33 = { class: "d-flex align-items-center fs-5 fw-bold mb-2" }
const _hoisted_34 = { class: "col-lg-12 fv-row" }
const _hoisted_35 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_36 = { class: "col-md-6 fv-row" }
const _hoisted_37 = { class: "d-flex align-items-center fs-5 fw-bold mb-2" }
const _hoisted_38 = { class: "col-lg-12 fv-row" }
const _hoisted_39 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "row mb-5" }
const _hoisted_42 = { class: "col-md-6 fv-row" }
const _hoisted_43 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_44 = { class: "fv-plugins-message-container" }
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = { class: "col-md-6 fv-row" }
const _hoisted_47 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "row mb-5" }
const _hoisted_51 = { class: "col-md-3 fv-row" }
const _hoisted_52 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_53 = { class: "fv-plugins-message-container" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = { class: "col-md-3 fv-row" }
const _hoisted_56 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_57 = { class: "fv-plugins-message-container" }
const _hoisted_58 = { class: "fv-help-block" }
const _hoisted_59 = { class: "col-md-6 fv-row" }
const _hoisted_60 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { class: "row mb-5" }
const _hoisted_64 = { class: "col-md-6 fv-row" }
const _hoisted_65 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_66 = { class: "fv-plugins-message-container" }
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = { class: "col-md-6 fv-row" }
const _hoisted_69 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_70 = { class: "fv-plugins-message-container" }
const _hoisted_71 = { class: "fv-help-block" }
const _hoisted_72 = { class: "row mb-5" }
const _hoisted_73 = { class: "col-md-6 fv-row" }
const _hoisted_74 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_75 = { class: "fv-plugins-message-container" }
const _hoisted_76 = { class: "fv-help-block" }
const _hoisted_77 = { class: "col-md-6 fv-row" }
const _hoisted_78 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_79 = { class: "fv-plugins-message-container" }
const _hoisted_80 = { class: "fv-help-block" }
const _hoisted_81 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_82 = { class: "d-flex align-items-center fs-5 fw-bold mb-2" }
const _hoisted_83 = { class: "required" }
const _hoisted_84 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_85 = ["value"]
const _hoisted_86 = { class: "fv-plugins-message-container" }
const _hoisted_87 = { class: "fv-help-block" }
const _hoisted_88 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_89 = { class: "col-md-6 fv-row" }
const _hoisted_90 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_91 = { class: "fv-plugins-message-container" }
const _hoisted_92 = { class: "fv-help-block" }
const _hoisted_93 = { class: "col-md-6 fv-row" }
const _hoisted_94 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_95 = { class: "fv-plugins-message-container" }
const _hoisted_96 = { class: "fv-help-block" }
const _hoisted_97 = { class: "row mb-5" }
const _hoisted_98 = { class: "col-md-6 fv-row" }
const _hoisted_99 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_100 = { class: "fv-plugins-message-container" }
const _hoisted_101 = { class: "fv-help-block" }
const _hoisted_102 = { class: "col-md-6 fv-row" }
const _hoisted_103 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_104 = { class: "fv-plugins-message-container" }
const _hoisted_105 = { class: "fv-help-block" }
const _hoisted_106 = { class: "col-12 fv-row" }
const _hoisted_107 = { class: "d-flex flex-column" }
const _hoisted_108 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_109 = { class: "fv-plugins-message-container" }
const _hoisted_110 = { class: "fv-help-block" }
const _hoisted_111 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_112 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_113 = { key: 1 }
const _hoisted_114 = { class: "symbol symbol-60px symbol-2by3 me-4" }
const _hoisted_115 = { class: "d-flex flex-row-fluid flex-wrap align-items-center" }
const _hoisted_116 = { class: "flex-grow-1 me-2" }
const _hoisted_117 = { class: "svg-icon-2 svg-icon-primary" }
const _hoisted_118 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_119 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_edit_property_submit",
  class: "btn btn-primary"
}
const _hoisted_120 = { class: "indicator-label" }
const _hoisted_121 = { class: "indicator-progress" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('update', 'auctions'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.translate('updateProperty')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn-light",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('backToList')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Form, {
            class: "form",
            id: "kt_edit_property_form",
            onSubmit: _ctx.submit,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate('PACI Number')), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        type: "number",
                        class: "form-control form-control-solid",
                        placeholder: _ctx.translate('paciNo'),
                        name: "paciNo",
                        modelValue: _ctx.property.paciNo,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.property.paciNo) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("button", {
                        type: "button",
                        id: "kt_account_profile_details_submit",
                        ref: "submitPullButton",
                        class: "btn btn-primary flex-shrink-0 p-2 m-2",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pullData && _ctx.pullData(...args)))
                      }, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.translate('pullData')), 1),
                        _createElementVNode("span", _hoisted_14, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_15
                        ])
                      ], 512)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_ErrorMessage, { name: "paciNo" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.translate('propertyType')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.property.propertyId,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.property.propertyId) = $event)),
                        required: true,
                        label: "title",
                        trackBy: "title",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.propertyTypes,
                        placeholder: _ctx.translate('selectPropertyType'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound'),
                        name: "selectedPropertyType"
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                      (_ctx.property.propertyId == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.translate('PROPERTY_TYPE_IS_REQUIRED_FIELD')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.translate('area')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.property.areaId,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.property.areaId) = $event)),
                        required: true,
                        label: "titleAr",
                        trackBy: "titleAr",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.areas,
                        placeholder: _ctx.translate('selectAreas'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound'),
                        name: "selectedArea"
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                      (_ctx.property.areaId == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.translate('AREA_IS_REQUIRED_FIELD')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('auctionDescription')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedAuctionDescription,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedAuctionDescription) = $event)),
                        label: "titleAr",
                        trackBy: "titleAr",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.auctionDescriptions,
                        placeholder: _ctx.translate('selectAuctionDescription'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound'),
                        name: "selectedAuctionDescription"
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                      (_ctx.property.areaId == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('auctionLocation')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedAuctionLocation,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedAuctionLocation) = $event)),
                        label: "titleAr",
                        trackBy: "titleAr",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.auctionLocations,
                        placeholder: _ctx.translate('selectAuctionLocation'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound'),
                        name: "selectedAuctionLocation"
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                      (_ctx.property.locationId == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.translate('PROPERTY_TYPE_IS_REQUIRED_FIELD')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.translate('block')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('propertyBlock'),
                      name: "block",
                      modelValue: _ctx.property.block,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.property.block) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_ErrorMessage, { name: "block" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.translate('plot')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('propertyPlot'),
                      name: "plot",
                      modelValue: _ctx.property.plot,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.property.plot) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_ErrorMessage, { name: "plot" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.translate('startingPrice')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('startingPrice'),
                      name: "startingPrice",
                      onInput: _cache[9] || (_cache[9] = ($event: any) => {
                  _ctx.updateStartingPricePerSqrM();
                  _ctx.updatePercentagePremiumPaid();
                }),
                      modelValue: _ctx.property.startingPrice,
                      "onUpdate:modelValue": [
                        _cache[10] || (_cache[10] = ($event: any) => ((_ctx.property.startingPrice) = $event)),
                        _ctx.onStartingPriceInput
                      ],
                      style: {"color":"red","font-weight":"bold"}
                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_ErrorMessage, { name: "startingPrice" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.translate('supplyPercentage')), 1),
                    _createVNode(_component_Field, {
                      type: "number",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('supplyPercentage'),
                      name: "supplyPercentage",
                      modelValue: _ctx.property.supplyPercentage,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.property.supplyPercentage) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_ErrorMessage, { name: "supplyPercentage" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.translate('size')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('propertySize'),
                      name: "size",
                      onInput: _cache[12] || (_cache[12] = ($event: any) => {
                  _ctx.updateStartingPricePerSqrM();
                  _ctx.updateSalePricePerSqm();
                }),
                      modelValue: _ctx.property.size,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.property.size) = $event)),
                      style: {"color":"#0066ff","font-weight":"bold"}
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_ErrorMessage, { name: "size" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.translate('additionalInfoEn')), 1),
                    _createVNode(_component_Field, {
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('additionalInfoInEn'),
                      name: "additionalInfoEn",
                      modelValue: _ctx.property.additionalInfoEn,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.property.additionalInfoEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_ErrorMessage, { name: "additionalInfoEn" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.translate('address')), 1),
                    _createVNode(_component_Field, {
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('address'),
                      name: "address",
                      modelValue: _ctx.property.address,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.property.address) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_ErrorMessage, { name: "address" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.translate('longitude')), 1),
                    _createVNode(_component_Field, {
                      type: "number",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('longitude'),
                      name: "longitude",
                      modelValue: _ctx.property.longitude,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.property.longitude) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createVNode(_component_ErrorMessage, { name: "longitude" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.translate('latitude')), 1),
                    _createVNode(_component_Field, {
                      type: "number",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('latitude'),
                      name: "latitude",
                      modelValue: _ctx.property.latitude,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.property.latitude) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createVNode(_component_ErrorMessage, { name: "latitude" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("label", _hoisted_82, [
                    _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.translate('propertyStatus')), 1)
                  ]),
                  _createVNode(_component_Field, {
                    name: "statusId",
                    class: "form-select form-select-solid",
                    as: "select",
                    modelValue: _ctx.property.statusId,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.property.statusId) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", _hoisted_84, _toDisplayString(_ctx.translate('selectStatus')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: status.id,
                          value: status.id
                        }, _toDisplayString(status.title), 9, _hoisted_85))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createVNode(_component_ErrorMessage, { name: "statusId" })
                    ])
                  ])
                ]),
                (_ctx.property.statusId == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.translate('salePrice')), 1),
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: _ctx.translate('salePrice'),
                          name: "salePrice",
                          onInput: _cache[19] || (_cache[19] = ($event: any) => {
                  _ctx.updateSalePricePerSqm();
                  _ctx.updatePercentagePremiumPaid();
                }),
                          modelValue: _ctx.property.salePrice,
                          "onUpdate:modelValue": [
                            _cache[20] || (_cache[20] = ($event: any) => ((_ctx.property.salePrice) = $event)),
                            _ctx.onSalePriceInput
                          ]
                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", _hoisted_92, [
                            _createVNode(_component_ErrorMessage, { name: "salePrice" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.translate('salePricePerSqm')), 1),
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: _ctx.translate('salePricePerSquareMeter'),
                          name: "salePricePerSqrM",
                          modelValue: _ctx.property.salePricePerSqrM,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.property.salePricePerSqrM) = $event))
                        }, null, 8, ["placeholder", "modelValue"]),
                        _createElementVNode("div", _hoisted_95, [
                          _createElementVNode("div", _hoisted_96, [
                            _createVNode(_component_ErrorMessage, { name: "salePricePerSqrM" })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.translate('startingPricePerSqm')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid input-disabled",
                      placeholder: _ctx.translate('startingPricePerSquareMeter'),
                      name: "startingPricePerSqrM",
                      disabled: "true",
                      modelValue: _ctx.property.startingPricePerSqrM,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.property.startingPricePerSqrM) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("div", _hoisted_101, [
                        _createVNode(_component_ErrorMessage, { name: "startingPricePerSqrM" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.translate('percentagePremiumPaid')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid input-disabled",
                      placeholder: _ctx.translate('percentagePremiumPaid'),
                      name: "percentagePremiumPaid",
                      disabled: "true",
                      modelValue: _ctx.property.percentagePremiumPaid,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.property.percentagePremiumPaid) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, [
                        _createVNode(_component_ErrorMessage, { name: "percentagePremiumPaid" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.translate('additionalInfoAr')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('additionalInfoAr'),
                      name: "additionalInfoAr",
                      modelValue: _ctx.property.additionalInfoAr,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.property.additionalInfoAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("div", _hoisted_110, [
                        _createVNode(_component_ErrorMessage, { name: "additionalInfoAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.translate('attachments')), 1),
                  (_ctx.showFileInput)
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 0,
                        type: "file",
                        accept: ".pdf,application/pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,application/msword,application/vnd.ms-excel,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.presentationml.presentation,.txt,text/plain,",
                        autocomplete: "off",
                        class: "form-control form-control-solid",
                        placeholder: _ctx.translate('propertyAttachments'),
                        name: "attachment"
                      }, null, 8, ["placeholder"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.property.auctionDetailsAttachment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("div", {
                          class: "symbol-label contain-symbol",
                          style: _normalizeStyle(`background-image: url('${_ctx.getAttachmentThumbnail()}')`)
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("div", _hoisted_116, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "text-gray-800 fw-bolder text-hover-primary fs-6 text-capitalize",
                            onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (
                    _ctx.downloadAttachment(_ctx.property.auctionDetailsAttachment)
                  ), ["prevent"]))
                          }, [
                            _createTextVNode("Download File "),
                            _createElementVNode("span", _hoisted_117, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr065.svg" })
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_118, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-white me-3",
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_119, [
                  _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_121, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_122
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}